// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__1-VgY","question":"Question_question__20G95","description":"Question_description__1-JNB"};